export enum RepliersListingLastStatus {
  'Sold' = 'Sld',
  'Leased' = 'Lsd',
  'New' = 'New',
  'PriceChanged' = 'Pc',
  'SoldConditionally' = 'Sc',
  'LeasedConditionally' = 'Lc',
  'Expired' = 'Exp',
  'Terminated' = 'Ter',
  'Suspended' = 'Sus',
  'Extended' = 'Ext',
  'DealFellThrough' = 'Dft',
  'SoldConditionallyExtended' = 'Sce',
}

export const lastStatusLabels = {
  [RepliersListingLastStatus.Sold]: 'Sold',
  [RepliersListingLastStatus.Leased]: 'Leased',
  [RepliersListingLastStatus.New]: 'New',
  [RepliersListingLastStatus.PriceChanged]: 'Price Changed',
  [RepliersListingLastStatus.SoldConditionally]: 'Sold Conditionally',
  [RepliersListingLastStatus.LeasedConditionally]: 'Leased Conditionally',
  [RepliersListingLastStatus.Expired]: 'Expired',
  [RepliersListingLastStatus.Terminated]: 'Terminated',
  [RepliersListingLastStatus.Suspended]: 'Suspended',
  [RepliersListingLastStatus.Extended]: 'Extended',
  [RepliersListingLastStatus.DealFellThrough]: 'Deal Fell Through',
  [RepliersListingLastStatus.SoldConditionallyExtended]:
    'Sold Conditionally Extended',
};
